module.exports = __webpack_public_path__ + "static/media/road-king-special-snake-venom.6a59ce53.png";